import React from 'react';
import ReactDOM from 'react-dom/client';
import '@carbon/styles/css/styles.css';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import { initializeNativeServices } from './services/native/nativeBootstrap';

// Native bootstrap ide PRE React render-a: deviceId se obezbeđuje rano, a push
// listeneri se registruju dok je WebView još svež (cold start tap na push).
// Na web-u je ovo no-op.
initializeNativeServices();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// Register the service worker so the app can be installed as a PWA
// (fullscreen, like a native app) on mobile devices.
serviceWorkerRegistration.register();
